var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCaretLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 192,
  height: 192,
  viewBox: "0 0 256 256"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h256v256H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M163.1 40.6a8.4 8.4 0 0 0-8.8 1.7l-80 80a8.1 8.1 0 0 0 0 11.4l80 80a8.3 8.3 0 0 0 5.7 2.3 8.5 8.5 0 0 0 3.1-.6 8 8 0 0 0 4.9-7.4V48a8 8 0 0 0-4.9-7.4Z"
})));
export default SvgCaretLeft;